<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/n6Kkmo/tc-custom/9781328518415.jpg?1730610461089" alt="This image is the cover for the book Auntie Poldi And The Handsome Antonio, The Auntie Poldi Adventures"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Auntie Poldi And The Handsome Antonio, The Auntie Poldi Adventures
      </h1>
      <p class="bookDescription body article font2">
        <b>The latest installment in Mario Giordano's best-selling series of charming mysteries, starring Sicily's most glamorous gumshoe, Auntie Poldi. <br/><br/></b>All the beloved, irascible Auntie Poldi wanted from her Sicilian retirement was time to enjoy the sunshine, a free-flowing supply of wine, and a sultry romance with Chief Inspector Vito Montana. But then her idyll is rudely disrupted by the last person she wants to see on her doorstep: John Owenya, detective inspector with the Tanzanian Ministry of Home Affairs, who is also her estranged lying cheat of a husband.<br/><br/>Not only is John's sudden reappearance putting a kink in Poldi's dreamy love affair with Montana, but his presence also comes with a plea for help—and unwanted clashes with the Mafia.<br/><br/>Where is John's half-brother? What is the ten-million-dollar "it" that John's brother was last seen with, which has both the Sicilian and the Tanzanian mobs in a frenzy? With only a postcard that has a phone number and a name, "Handsome Antonio," on the back, Auntie Poldi hops begrudgingly (albeit with a great deal of gumption and panache) back into the saddle (in this case, an immaculate red Maserati Cabrio from the eighties with cream leather upholstery). The faster she finds Handsome Antonio, the sooner she can get John Owenya out of her hair and her love life. But the people Poldi discovers along the way may very well knock her immaculate wig askew.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mario Giordano
      </h2>
      
      <p class="authorDescription body article">MARIO GIORDANO, the son of Italian immigrants, was born in Munich. <I>Auntie Poldi and the Sicilian Lions,</I> his first novel translated into English, was an Indie Next Pick, a Barnes &amp;Noble Discover selection, an Amazon Best Book of the Month, and a Costco Staff Pick. He lives in Berlin.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1ea9f666